import branditRails from '../../../../api/brandit_rails'
import {
  setBudgetManagementStatusAction,
  setBudgetManagementDataAction,
  setBudgetManagementErrorsAction,
  clearBudgetManagementAction
} from './budgetManagement.actions'

export const fetchBudgetManagementSystem = locationId => async dispatch => {
  try {
    dispatch(setBudgetManagementStatusAction('loading'))

    const { data } = await branditRails.get(`/locations/${locationId}/budget_management_system`)

    dispatch(setBudgetManagementDataAction(data))
    dispatch(setBudgetManagementStatusAction('succeeded'))
  } catch (err) {
    dispatch(setBudgetManagementStatusAction('failed'))
    dispatch(clearBudgetManagementAction())
    dispatch(
      setBudgetManagementErrorsAction({
        action: 'fetchBudgetManagementSystem',
        message: err.response?.data?.error || err.message || 'Failed to fetch budget management system'
      })
    )
  }
}
